import { REACT_APP_API_URL } from 'helpers/conf';
import { GOOGLE_OAUTH_PATH } from '../constants';

// The provider callback is registered against the API origin, so the flow has
// to start there and not from window.location.
export const getGoogleAuthUrl = () =>
  `${REACT_APP_API_URL}${GOOGLE_OAUTH_PATH}`;
